<svg [attr.height]="size" [attr.width]="size" fill="transparent">
  <rect [attr.width]="size" [attr.height]="size"/>
</svg>
